import { NoteTextarea } from "@/components/forms/NoteTextarea";
import { Card, Field, PageContainer, SectionHeader } from "@/components/ui";
import { SetStateAction } from "jotai";
import { Dispatch } from "react";

export default function AdditionalInfo({ specialInstructions, setSpecialInstructionsAction }: {
  specialInstructions: string
  setSpecialInstructionsAction: Dispatch<SetStateAction<string>>
}) {
  return (
    <PageContainer className="mb-8">
      <Card>
        <SectionHeader title="Observações" size="title" descriptionSize="base" description="Sobre qualquer detalhe do seu pedido" />
        <Field label="Observações do pedido" hideLabel className="items-end">
          <NoteTextarea
            value={specialInstructions}
            onChange={setSpecialInstructionsAction}
            placeholder='Escreva sua observação aqui'
            className="p-4"
            counterClassName="text-sm"
          />
        </Field>
      </Card>
    </PageContainer>
  );
}
